import { useState, useMemo, useRef } from 'react';
import clsx from 'clsx';
import { getDirections, getOffsets } from '../../shared/helpers';
import * as styles from './style.module.css';
import Target from './Target';
import Bubble from './Bubble';
const useBubble = ({ direction = 'down', offset, margin, maxWidth, isLargeViewport = true, id, hideNubbin = false, overlayClassName, }) => {
    // IDs
    const prefix = 'bubble';
    const bubbleId = id ? `${prefix}-${id}` : `${prefix}`;
    const headerId = id ? `${prefix}-header-${id}` : `${prefix}-header`;
    const interactiveId = id
        ? `${prefix}-interactive-${id}`
        : `${prefix}-interactive`;
    // Derived values
    const { mainDirection, secondaryDirection } = useMemo(() => getDirections(direction), [direction]);
    const { xOffset, yOffset } = useMemo(() => getOffsets(mainDirection, secondaryDirection, offset), [mainDirection, secondaryDirection, offset]);
    // Refs
    const refInteractiveElement = useRef(null);
    // States
    const [visible, setVisible] = useState(false);
    // Classes
    const targetClasses = clsx(styles.root, styles.interactiveElement, styles[mainDirection], styles[secondaryDirection], isLargeViewport && styles.largeViewport, visible && styles.visible, hideNubbin && styles.hideNubbin);
    const largeViewportWrapperClasses = clsx(styles.root, styles.bubble, styles[mainDirection], styles[secondaryDirection], styles.largeViewport, visible && styles.visible, hideNubbin && styles.hideNubbin);
    const overlayClasses = clsx(styles.overlay, visible && styles.visible, overlayClassName);
    const bubbleClasses = clsx(styles.bubble, styles.smallViewport, visible && styles.visible, hideNubbin && styles.hideNubbin);
    return {
        visible,
        setVisible,
        targetProps: {
            maxWidth,
            margin,
            xOffset,
            yOffset,
            targetClasses,
        },
        triggerProps: {
            id: interactiveId,
            ref: refInteractiveElement,
        },
        bubbleProps: {
            bubbleId,
            headerId,
            largeViewportWrapperClasses,
            overlayClasses,
            bubbleClasses,
            isLargeViewport,
        },
    };
};
useBubble.Target = Target;
useBubble.Bubble = Bubble;
export default useBubble;
//# sourceMappingURL=index.js.map